<template>
  <div class="modal fade" :id="id" data-bs-backdrop="true"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" v-bind:class="'modal-' + size">
      <div class="modal-content overflow-visible">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">{{title}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div :class="['modal-body overflow-scroll', { 'mh-300': minHeight } ]">
          <slot name="body">
            <!-- video tag-->
            <div v-if="videoLink">
              <div class="text-center">
                <video controls>
                  <source :src="videoLink" type="video/mp4">
                </video>
              </div>
            </div>
            <!-- iframe tag -->
            <div v-if="videoLinkYoutube">
              <div class="text-center">
                <iframe width="100%" height="450" :src="videoLinkYoutube" frameborder="0" allowfullscreen="" controls></iframe>
              </div>
            </div>
            <!-- component -->
            <div v-if="component">
              <component v-bind:is="component"></component>
            </div>
            <!-- text  -->
            <div v-else>
              <p>{{ innerContent }}</p>
            </div>
          </slot>
        </div>
        <div v-if="!hideFooter" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
export default {
  name: 'BaseModal',
  props: {
    isOpen: {},
    id: {},
    title: {},
    content: {},
    innerContent: { default: '' },
    component: {},
    videoLink: {},
    videoLinkYoutube: {},
    size: {
      default: 'md'
    },
    hideFooter: {
      default: false
    },
    minHeight: {
      default: false
    }
  },

  watch: {
    isOpen (val) {
      if (val) this.open()
      else this.modal.hide()
    }
  },

  data () {
    return {
      modal: null
    }
  },

  mounted () {
    const modalEl = document.getElementById(this.id)
    this.modal = new Modal(modalEl,{ focus: false })
    modalEl.addEventListener('hidden.bs.modal', () => {
      this.$emit('close')
    })
  },

  methods: {
    close () {
      this.modal.hide()
      this.$emit('close')
    },

    open () {
      this.modal.show()
      this.$emit('show')
    }
  }
}
</script>
<style scoped>
video, iframe{
  max-width:100%;
}
.mh-300 {
  min-height: 300px;
}
</style>
